import { Tooltip } from '@material-ui/core'
import React from 'react'

import { HelpIcon, HintText } from '../styled'

import iconHelp from '../../../../../img/registration/icon-help.svg'

export interface BasicTooltipProps {
  contents: string | NonNullable<React.ReactNode>
  openDirection?: 'left' | 'right' | 'top' | 'bottom'
  className?: string
}

const BasicTooltip: React.FC<BasicTooltipProps> = ({
  contents,
  openDirection = 'right',
  className = '',
}) => (
  <Tooltip
    title={typeof contents === 'string' ? <HintText>{contents}</HintText> : contents}
    placement={openDirection}
    enterTouchDelay={0}
    leaveTouchDelay={5000}
    className={className}
    interactive
    arrow
  >
    <HelpIcon src={iconHelp} alt="Help" />
  </Tooltip>
)

export default BasicTooltip
